function toTypeStringOfObjectId (value) {
  return `ObjectId('${value}')`
}

async function findPricebook ({ key, server }) {
  const { data: pricebook } = await server.get({
    url: 'api/model/pricebooks',
    query: {
      query: {
        key,
      },
    },
  })
  return pricebook
}

const isInvisable = v => v === '' || v === undefined || v === null

function hasLensSpec (value) {
  const { lensSpec } = value
  if (!lensSpec) return false

  const { s, c } = lensSpec
  if (isInvisable(s)) return false
  if (isInvisable(c)) return false

  return true
}

async function findBPrice ({ pricebookRef, productSpec, server }) {
  const { productRef, s, c } = productSpec
  const { data: priceRanges } = await server.get({
    url: 'api/model/priceRanges',
    query: {
      query: {
        productRef: toTypeStringOfObjectId(productRef._id),
        range: {
          $elemMatch: { s: s * 100, c: c * 100 },
        },
      },
    },
  })

  if (priceRanges.length === 0) return undefined

  const { data: prices } = await server.get({
    url: 'api/model/prices',
    query: {
      query: {
        pricebookRef: toTypeStringOfObjectId(pricebookRef),
        priceRangeRef: toTypeStringOfObjectId(priceRanges[0]._id),
      },
    },
  })

  if (prices.length === 0) return undefined

  return prices[0].price
}

async function findPrice ({ value, server }) {
  const { productRef } = value
  if (!productRef) return undefined

  const pdtType = productRef.type
  if (pdtType === 'B' && !hasLensSpec(value)) return undefined

  const pricebooks = await findPricebook({ key: '批發價', server })
  if (pricebooks.length === 0) return undefined
  const pricebookRef = pricebooks[0]._id

  if (pdtType === 'B') {
    const { lensSpec: { s, c } } = value
    const productSpec = { productRef, s, c }
    const price = await findBPrice({ pricebookRef, productSpec, server })
    return price
  }

  const { data: prices } = await server.get({
    url: 'api/model/prices',
    query: {
      query: {
        pricebookRef: toTypeStringOfObjectId(pricebookRef),
        productRef: toTypeStringOfObjectId(productRef._id),
      },
    },
  })
  if (prices.length === 0) return null
  return prices[0].price
}

export default async function ({ value, server }) {
  const unitPrice = await findPrice({ value, server })
  return unitPrice
}



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/ItemsEditor/ItemEditor/findPrice.js